
import React from 'react'
import Page from '../components/Page';
import { IonFab, IonFabButton, IonItem, IonList, IonIcon } from '@ionic/react';
import { add } from 'ionicons/icons';

export default class Mule extends React.Component {

  constructor(props){
    super(props);
    if(!localStorage.getItem('muleCharacters')) localStorage.setItem('muleCharacters', JSON.stringify([]));
  }
  
  renderMuleCharactersList() {
    let chars = JSON.parse(localStorage.getItem('muleCharacters'));
    if(chars.length == 0) return <p style={{padding: 13}}><i>You don't have any mule characters yet. Add your first one below!</i></p>
    return chars.map(c => (
      <IonItem routerLink={"/mule/"+c.name} key={c.name}>
        {c.name}
      </IonItem>
    ))
  }

  render(){
    return (
      <Page large title="Mule characters" renderDirectChildren={() => (
        <IonFab vertical="bottom" horizontal="center" slot="fixed">
          <IonFabButton color="secondary" onClick={() => {
            let name = window.prompt('Mule character name?');
            if(!name || name.length == 0) {
              alert('Input invalid');
              return;
            }
            let chars = JSON.parse(localStorage.getItem('muleCharacters'));
            chars.push({name: name});
            localStorage.setItem("muleCharacters",JSON.stringify(chars));
            this.forceUpdate();
          }}>
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>
      )}>
        <IonList>
          {this.renderMuleCharactersList()}
        </IonList>
      </Page>
    )
  }
}
